import React from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

export default function FormSuccess() {
  return (
    <Container component="main" maxWidth="sm">
      <Stack alignItems="center" justifyContent="center" spacing={4} sx={{ minHeight: '100vh', px: 2 }}>
        <Stack alignItems="center" justifyContent="center" sx={{ bgcolor: 'success.light', borderRadius: '50%', width: 100, height: 100 }}>
          <CheckCircleOutline color="success" sx={{ fontSize: 48 }} />
        </Stack>
        <Stack alignItems="center" spacing={1.5}>
          <Typography variant="h4" fontWeight={700} align="center">
            We&apos;ve received your form.
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center">
            We&apos;ll be in touch if anything else is needed.
          </Typography>
        </Stack>
        <Typography variant="caption" color="text.secondary">
          You can close this tab at any time.
        </Typography>
      </Stack>
    </Container>
  );
}
